/**
 * @generated SignedSource<<348adb76bbf4f110822a883183aa426f>>
 * @relayHash 65eaeffc7d49cbfbdabaa3df12f1ca03
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cec9945748f8de03d3172e831e29a0dbbb45ce8c376e1c6485a0e61d646edcd0

import type { ConcreteRequest } from 'relay-runtime';
export type WatchSettingsCheckboxItemsWatchDialogUnwatchBlogsMutation$variables = {
  spaceId: string;
};
export type WatchSettingsCheckboxItemsWatchDialogUnwatchBlogsMutation$data = {
  readonly unwatchBlogs: {
    readonly space: {
      readonly currentUser: {
        readonly isWatchingBlogs: boolean;
      };
      readonly id: string | null | undefined;
    };
  } | null | undefined;
};
export type WatchSettingsCheckboxItemsWatchDialogUnwatchBlogsMutation = {
  response: WatchSettingsCheckboxItemsWatchDialogUnwatchBlogsMutation$data;
  variables: WatchSettingsCheckboxItemsWatchDialogUnwatchBlogsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceId"
  }
],
v1 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Literal",
            "name": "currentUser",
            "value": true
          },
          {
            "kind": "Variable",
            "name": "spaceId",
            "variableName": "spaceId"
          }
        ],
        "kind": "ObjectValue",
        "name": "watchSpaceInput"
      }
    ],
    "concreteType": "WatchSpacePayload",
    "kind": "LinkedField",
    "name": "unwatchBlogs",
    "plural": false,
    "selections": [
      {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "concreteType": "SpaceUserMetadata",
            "kind": "LinkedField",
            "name": "currentUser",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "isWatchingBlogs"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "WatchSettingsCheckboxItemsWatchDialogUnwatchBlogsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WatchSettingsCheckboxItemsWatchDialogUnwatchBlogsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "65eaeffc7d49cbfbdabaa3df12f1ca03",
    "id": "cec9945748f8de03d3172e831e29a0dbbb45ce8c376e1c6485a0e61d646edcd0",
    "metadata": {},
    "name": "WatchSettingsCheckboxItemsWatchDialogUnwatchBlogsMutation",
    "operationKind": "mutation",
    "text": "mutation WatchSettingsCheckboxItemsWatchDialogUnwatchBlogsMutation($spaceId:ID!){unwatchBlogs(watchSpaceInput:{spaceId:$spaceId,currentUser:true}){space{id,currentUser{isWatchingBlogs}}}}"
  }
};
})();

(node as any).hash = "3fc1a3ec86be09c73864b27362d2f1a6";

export default node;
